<template>
  <div class="gf-diff-statistics">
    <span v-if="changedFilesNumber">
      <i class="gf-icon gf-icon-file"></i>
      {{ $t('commit.files.changed') }}: {{ changedFilesNumber }}
    </span>
    <div
      class="gf-diff-statistics__lines"
      v-if="addedLinesNumber > 0 || removedLinesNumber > 0"
    >
      <span>
        <span class="text-success">+{{ addedLinesNumber }}</span>
        <span class="text-danger ml-1">–{{ removedLinesNumber }}</span>
      </span>
      <div class="gf-diff-statistics__lines-squares">
        <div
          class="gf-diff-statistics__lines-squares-item"
          v-for="(squareColor, index) in squaresColors"
          :key="index"
          :style="{ 'background-color': squareColor }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import CommitMessages from '@/shared-modules/modules/commit/commit.messages';

export default {
  name: 'GfDiffStatistics',
  props: {
    addedLinesNumber: {
      type: Number,
      default: 0
    },
    removedLinesNumber: {
      type: Number,
      default: 0
    },
    changedFilesNumber: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      squaresColors: []
    };
  },
  computed: {
    // количество измененных линий
    diffLinesSum() {
      return this.addedLinesNumber + this.removedLinesNumber;
    },
    // процент добавленных линий
    addedLinesPercentage() {
      return Math.round((this.addedLinesNumber * 100) / this.diffLinesSum);
    },
    // процент удаленных линий
    removedLinesPercentage() {
      return 100 - this.addedLinesPercentage;
    }
  },
  mounted() {
    this.fillSquares();
  },
  methods: {
    fillSquares() {
      this.squaresColors = [];
      const squareCoefficient = 100 / 6;
      let addedSquaresNumber = Math.round(this.addedLinesPercentage / squareCoefficient);
      let removedSquaresNumber = 6 - addedSquaresNumber;
      if (this.addedLinesNumber > 0 && addedSquaresNumber === 0) {
        addedSquaresNumber += 1;
        removedSquaresNumber -= 1;
      }
      if (this.removedLinesNumber > 0 && removedSquaresNumber === 0) {
        removedSquaresNumber += 1;
        addedSquaresNumber -= 1;
      }
      for (let i = 0; i < 6; i++) {
        if (addedSquaresNumber > 0) {
          this.squaresColors.push('var(--success)');
          addedSquaresNumber -= 1;
        } else if (removedSquaresNumber > 0) {
          this.squaresColors.push('var(--danger)');
          removedSquaresNumber -= 1;
        } else {
          this.squaresColors.push('var(--bg-light-selected)');
        }
      }
    }
  },
  i18n: {
    messages: CommitMessages
  }
};
</script>

<style lang="scss">
$this: '.gf-diff-statistics';

#{$this} {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
  text-wrap: nowrap;

  #{$this}__lines {
    display: flex;
    align-items: center;
    gap: 8px;

    &-squares {
      display: flex;
      gap: 1px;

      &-item {
        width: 8px;
        height: 8px;
        border-radius: 2px;
      }
    }
  }
}
</style>
